import { LocaleType } from "../../../../../../constants/constants";

export class ReportOperationDataCommand {
    private readonly _operationCode: string;
    private readonly _contactName: string;
    private readonly _contactEmail: string;
    private readonly _contactPhone: string;
    private readonly _issueValue: string;
    private readonly _description: string;
    private readonly _locale: LocaleType;

    constructor(operationCode: string, contactName: string, contactEmail: string, contactPhone: string,
                topic: string, description: string, locale: LocaleType) {
        this._operationCode = operationCode;
        this._contactName = contactName;
        this._contactEmail = contactEmail;
        this._contactPhone = contactPhone;
        this._issueValue = topic;
        this._description = description;
        this._locale = locale;
    }

    get operationCode() {
        return this._operationCode;
    }

    get contactName() {
        return this._contactName;
    }

    get contactEmail() {
        return this._contactEmail;
    }

    get contactPhone() {
        return this._contactPhone;
    }

    get issueValue() {
        return this._issueValue;
    }

    get description() {
        return this._description;
    }

    get locale() {
        return this._locale;
    }
}
